import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from "lucide-react";
import { restaurantInfo } from "../mock";

const footerLinks = [
  ["Home", "/"],
  ["About Us", "/about"],
  ["Our Menu", "/menu"],
  ["Gallery", "/gallery"],
  ["Reservations", "/reservations"],
  ["Contact", "/contact"]
];

export function FooterBrand() {
  return (
    <div>
      <div className="flex items-center gap-3 mb-5">
  
<div className="w-12 h-12 flex items-center justify-center">
  <img
    src="/image/logo/logo spice.png"
    alt="Sea Spice Kitchen"
    className="w-12 h-12 object-contain"
  />
</div>
  <div>
    <div className="font-display text-white text-xl">
      Sea Spice Kitchen
    </div>
    <div className="text-[10px] tracking-[0.3em] uppercase text-spice-gold">
      Coastal Fusion
    </div>
  </div>
</div>
      <p className="text-sm leading-relaxed text-white/65">
        Frankston&apos;s home of coastal fusion dining. Fresh Australian seafood meets global flavours in a warm, welcoming setting.
      </p>
      <div className="flex items-center gap-3 mt-6">
        <a href="#" aria-label="Instagram" className="w-9 h-9 border border-white/20 hover:border-spice-gold hover:text-spice-gold flex items-center justify-center transition-colors">
          <Instagram size={16} />
        </a>
        <a href="#" aria-label="Facebook" className="w-9 h-9 border border-white/20 hover:border-spice-gold hover:text-spice-gold flex items-center justify-center transition-colors">
          <Facebook size={16} />
        </a>
      </div>
    </div>
  );
}

export function FooterLinks() {
  return (
    <div>
      <h4 className="font-display text-spice-gold text-lg mb-5 tracking-wide">Explore</h4>
      <ul className="space-y-3 text-sm">
        {footerLinks.map(([label, to]) => (
          <li key={to}>
            <Link to={to} className="text-white/65 hover:text-spice-gold transition-colors">
              {label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}

export function FooterVisit() {
  return (
    <div>
      <h4 className="font-display text-spice-gold text-lg mb-5 tracking-wide">Visit</h4>
      <ul className="space-y-4 text-sm">
        <li className="flex items-start gap-3">
          <MapPin size={16} className="text-spice-gold flex-shrink-0 mt-0.5" />
          <span className="text-white/65 leading-relaxed">
            {restaurantInfo.address.line1}<br />
            {restaurantInfo.address.line2}
          </span>
        </li>
        <li className="flex items-center gap-3">
          <Phone size={16} className="text-spice-gold flex-shrink-0" />
          <a href={`tel:${restaurantInfo.phone}`} className="text-white/65 hover:text-spice-gold">
            {restaurantInfo.phoneDisplay}
          </a>
        </li>
        <li className="flex items-center gap-3">
          <Mail size={16} className="text-spice-gold flex-shrink-0" />
          <a href={`mailto:${restaurantInfo.email}`} className="text-white/65 hover:text-spice-gold break-all">
            {restaurantInfo.email}
          </a>
        </li>
      </ul>
    </div>
  );
}

export function FooterHours() {
  return (
    <div>
      <h4 className="font-display text-spice-gold text-lg mb-5 tracking-wide">Opening Hours</h4>
      <ul className="space-y-3 text-sm text-white/65">
        <li className="flex items-start gap-3">
          <Clock size={16} className="text-spice-gold flex-shrink-0 mt-0.5" />
          <div>
             <div className="text-white/90">Mon – Sun</div>
            <div>{restaurantInfo.hours.weekends}</div>
          </div>
        </li>
        <li className="flex items-start gap-3 pl-7">
          <div>
            <div className="text-white/90">Seven Days</div>
            <div>Open</div>
          </div>
        </li>
      </ul>
    </div>
  );
}
